<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" transform="matrix(-1 0 0 1 24 0)" fill="url(#paint0_linear_7286_2234)" />
    <path d="M11 16L7 12L11 8M17 16L13 12L17 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_7286_2234" x1="-3.82007" y1="-20.1667" x2="35.734" y2="-13.0015" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
